import { isUndefined } from 'lodash-es';

export enum SortDirection {
  Ascending = 'Ascending',
  Descending = 'Descending'
}

export type Sorting<C = string> = Readonly<[column: C, direction: SortDirection]> | Readonly<[]>;

export function determineNextSorting<C>([sortColumn, sortDirection]: Sorting<C>, column: C): Sorting<C> {
  if (sortColumn === column) {
    if (sortDirection === SortDirection.Ascending) {
      return [column, SortDirection.Descending];
    }
    if (sortDirection === SortDirection.Descending) {
      return [];
    }
  }
  return [column, SortDirection.Ascending];
}

export function getSortDirection<C>([sortColumn, sortDirection]: Sorting<C>, column: C): SortDirection | undefined {
  if (column !== sortColumn || !isValidSortDirection(sortDirection)) {
    return undefined;
  }
  return sortDirection;
}

export function isValidSortDirection(sortDirection: string | undefined): sortDirection is SortDirection {
  return (
    isUndefined(sortDirection) ||
    sortDirection === SortDirection.Ascending ||
    sortDirection === SortDirection.Descending
  );
}
